import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импорт переводов
const en = require('./locales/en.json');
const ru = require('./locales/ru.json');

const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ru',
    // Языков интерфейса два; «ru-RU» из браузера — это «ru» (иначе переключатель видит «RU-RU»
    // и сравнение с 'ru' не срабатывает), неизвестный язык — fallback.
    supportedLngs: ['ru', 'en'],
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
  });

export default i18n;
